import CategoryMenu from "../../model/Category";
import categoryInfo from "../../model/categoryInfo";

export function setCategories(setState: React.Dispatch<React.SetStateAction<CategoryMenu>>, categories: categoryInfo[]): void {
    setState({ categories: categories });
}
